import { render, staticRenderFns } from "./ShipmentStopCard.vue?vue&type=template&id=580e0297&"
import script from "./ShipmentStopCard.vue?vue&type=script&lang=js&"
export * from "./ShipmentStopCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports